import { memo, useEffect } from "react";

import { Route, Routes } from "react-router-dom";
import { LoadingShim } from "@narmi/design_system";
import { ComposeProviders, modules } from "byzantine";
import { type WireType } from "byzantine/src/dbbl/businessLogic/modules/internationalWires";

import SendViaTemplate from "./SendViaTemplate";

const Providers = [
  modules.wireTemplates.bootstrap.Provider,
  modules.wireTemplates.methodSelectorForm.Provider,
  modules.wireTemplates.sendViaTemplateForm.Provider,
];

const WireTemplatesScreen = memo(function WireTemplatesScreen({
  setWireType,
  wireType,
}: {
  setWireType: (wireType: WireType) => void;
  wireType: WireType;
}) {
  const { loading, load } = modules.wireTemplates.bootstrap.useBootstrap();
  useEffect(() => {
    load();
  }, [load]);

  if (loading) {
    return (
      <LoadingShim isLoading>
        <div style={{ height: "100vh" }} />
      </LoadingShim>
    );
  }
  return (
    <Routes>
      <Route
        path="/"
        element={
          <SendViaTemplate setWireType={setWireType} wireType={wireType} />
        }
      />
    </Routes>
  );
});

function Bootstrapped({
  setWireType,
  wireType,
}: {
  setWireType: (wireType: WireType) => void;
  wireType: WireType;
}) {
  return (
    <ComposeProviders components={Providers}>
      <WireTemplatesScreen setWireType={setWireType} wireType={wireType} />
    </ComposeProviders>
  );
}

export default memo(Bootstrapped);
